import { useQuery } from "@tanstack/react-query";

export function GetProfesionales() {
   const url = process.env.REACT_APP_URL_DIR + "users?perfil=Profesional";
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["users"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json())
   });
   return data;
}
